'use client';

import type { ReactElement } from 'react';
import { XYCHART_SERIES_TYPE, type XYChartLayout } from './xychart-types';

export interface XYChartCanvasDefsProps {
  layout: XYChartLayout;
  safeId: string;
}

export function XYChartCanvasDefs({
  layout,
  safeId,
}: XYChartCanvasDefsProps): ReactElement {
  const barSeries = layout.series.filter(
    (series) => series.type === XYCHART_SERIES_TYPE.Bar,
  );
  const lineSeries = layout.series.filter(
    (series) => series.type === XYCHART_SERIES_TYPE.Line,
  );

  return (
      <defs>
        {barSeries.map((series) => (
          <linearGradient
            key={`bar-grad-${series.seriesIndex}`}
            id={`${safeId}-bar-${series.seriesIndex}`}
            x1="0"
            y1="0"
            x2={layout.horizontal ? '1' : '0'}
            y2={layout.horizontal ? '0' : '1'}
          >
            <stop
              offset="0%"
              stopColor={series.color}
              stopOpacity={0.95}
            />
            <stop
              offset="100%"
              stopColor={series.color}
              stopOpacity={0.55}
            />
          </linearGradient>
        ))}
        {lineSeries.map((series) => (
          <linearGradient
            key={`area-grad-${series.seriesIndex}`}
            id={`${safeId}-area-${series.seriesIndex}`}
            x1="0"
            y1="0"
            x2={layout.horizontal ? '1' : '0'}
            y2={layout.horizontal ? '0' : '1'}
          >
            <stop
              offset="0%"
              stopColor={series.color}
              stopOpacity={0.32}
            />
            <stop
              offset="100%"
              stopColor={series.color}
              stopOpacity={0}
            />
          </linearGradient>
        ))}
      </defs>
  );
}
